namespace Reviews {

    export enum ReviewStatus {
        CannotLeaveReview = 0,
        CanLeaveReview = 1,
        HasLeftReview = 2
    }

    export enum TagType {
        Hotel = 1,
        Location = 2
    }

    export enum RatingType {
        Hotel = 1,
        Location = 2,
        Service = 3
    }

    export enum TravellerType {
        Solo = 1,
        Couple = 2,
        Family = 3,
        Friends = 4,
        Business = 5
    }

    /**
     * API Interfaces
     */
    export interface ApiTag {
        Type: TagType;
        Title: string;
    }

    export interface ApiReviewDetailsLeadContact {
        County: string;
        FirstName: string;
        LastName: string;
        Title: string;
    }

    export interface ApiReviewDetailsResponse {
        BookingRef: string;
        BookingType: number;
        CheckInDate: string;
        EstabId: number;
        Hotel: ApiHotelDetails;
        LeadContact: ApiReviewDetailsLeadContact;
        ReviewStatus: ReviewStatus;
    }

    export interface ApiHotelDetails {
        Address: string;
        CustomerRating: number;
        CustomerRatingCount: number;
        CustomerRatingTitle: string;
        Destinations: ApiDestination[];
        EstabId: number;
        Latitude: number;
        Longitude: number;
        StarRating: number;
        Title: string;
        Url: string;
    }

    export interface ApiDestination {
        Id: number;
        Type: number;
        Title: string;
    }

    export interface ApiReviewData {
        Anonymous :boolean;
        BookingId :number;
        Comments :string | null;
        Ratings :ApiRating[];
        Tags :ApiTag[];
        Title :string | null;
        TravellerType :TravellerType;
    }

    export interface ApiRating {
        Type :RatingType;
        Score :number;
    }
    /*
    * Classes and Interfaces used by controllers, directives
     */
    export class TagLists {
        hotel: string[] = [];
        location: string[] = [];
    }

    export class ReviewData {
        anonymous: boolean;
        ratings: { location: number, room: number, service: number };
        tags: { hotel: string[], location: string[] };
        travellerType: string;
        title: string;
        text: string;

        constructor() {
            this.anonymous = false;
            this.ratings = { location : 0, room : 0, service : 0 };
            this.tags = { hotel : [], location : []};
            this.travellerType = this.title = this.text = '';
        }

        dateReviewed = () :string => {
            return new Date().toISOString().slice(0,10);
        }

        overallRating = () :number => {
            let {location, room, service} = this.ratings;
            return Math.floor((location + room + service) / 3);
        }

        getRatingData= () :{} => {
            return {
                OverallRating : this.overallRating(),
                Location: this.ratings.location,
                Room: this.ratings.room,
                Service: this.ratings.service
            };
        }
    }

    export class ContactDetails {
        county: string;
        firstname :string;
        lastname :string;
        title :string;

        constructor() {
            this.county = this.firstname = this.lastname = this.title = '';
        }
    }

    export class HotelInformation {
        address :string;
        id: number;
        imageUrl :string;
        location :string;
        starRating :number;
        title :string;

        constructor() {
            this.address = this.imageUrl = this.location = this.title = '';
            this.id = this. starRating = 0;
        }
    }

    export class ReviewDetails {
        contactDetails :ContactDetails = new ContactDetails();
        checkedInDate :string = '';
        hotelDetails :HotelInformation = new HotelInformation();
        reviewStatus :ReviewStatus;
    }
}
